import React, { ComponentProps, Ref } from 'react';
import {
    ButtonText,
    IconWrapper,
    StyledButton,
    StyledIcon,
    Wrapper,
} from '~/shared/styles/Button/styles';
import { theme } from '~/theme';
import { LoadingSpinner } from '../LoadingSpinner';

export type { ButtonColorOptions, ButtonProps } from './types';

export const Button = ({
    children,
    color = theme.colors.brandBlue,
    customIcon,
    isLoading,
    wrapperClass,
    noIcon,
    onClick,
    variant = 'fill',
    ref,
    ...restProps
}: ComponentProps<typeof StyledButton> & { ref?: Ref<any> }) => {
    function onClickHandler(event: React.MouseEvent<HTMLButtonElement>) {
        if (isLoading) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }
        onClick?.(event);
    }

    return (
        <StyledButton
            color={color}
            ref={ref}
            isLoading={isLoading}
            onClick={onClickHandler}
            variant={variant}
            {...restProps}
        >
            <Wrapper className={wrapperClass}>
                <ButtonText>{children}</ButtonText>
                {noIcon ? null : (
                    <IconWrapper>{customIcon ? customIcon : <StyledIcon />}</IconWrapper>
                )}
            </Wrapper>
            {isLoading ? <LoadingSpinner /> : null}
        </StyledButton>
    );
};
